<template>
  <v-card id="resource-sent-list">
    <v-card-title>
      Who Viewed This Resource?
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table-thead, table-tbody"
      ></v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="sent_resources_users"
        :search="search"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
        no-data-text="No users viewed this resource during this time"
      >
        <template v-slot:item.lastViewed="{ item }">
          {{ item.lastViewed | normalDate }}
        </template>

        <template v-slot:item.fullName="{ item }">
          <v-row dense>
            <v-col cols="auto">
              <user-avatar :user="item" size="30"></user-avatar>
            </v-col>
            <v-col cols="auto">
              <div class="subtitle-1">
                {{ item.fullName }}
              </div>
              <div>
                {{ item.jobTitle }}
              </div>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ResourceSentUserList",
  components: {},
  props: {
    loading: { type: Boolean, default: false }
  },
  data: () => ({
    search: "",
    options: {},
    headers: [
      { text: "Employee", value: "fullName" },
      { text: "Last Viewed", value: "lastViewed" },
      { text: "View Count", value: "viewedCount" }
    ]
  }),
  computed: {
    ...mapGetters({ sent_resources_users: "reporting/sent_resources_users" })
  },
  created() {},
  methods: {}
};
</script>
